define(['jquery'], function ($) {
    var methods = {
        init: function (options) {
            var defaults = {
                menuWidth: 300,
                edge: 'left',
                closeOnClick: false,
                onOpen: null,
                onClose: null
            };
            options = $.extend(defaults, options);

            $(this).each(function () {
                var $this = $(this);
                var menuId = $this.attr('data-activates');
                var menu = document.getElementById(menuId);
                var menuOut = false;

                menu.classList.add('side-nav--inited');
                $this.removeClass('side-nav--inited');

                if (options.edge === 'left') {
                    menu.style.transform = 'translateX(-100%)';
                } else {
                    menu.classList.add('right-aligned');
                    menu.style.transform = 'translateX(100%)';
                }

                // If fixed sidenav, bring menu out
                if (menu.classList.contains('fixed')) {
                    if (window.innerWidth > 992) {
                        menu.style.transform = 'translateX(0)';
                    }
                }

                var closeButton = menu.querySelector('.side-nav-close-button');

                closeButton.addEventListener('click', function () {
                    removeMenu();
                });

                // Window resize to reset on large screens fixed
                if (menu.classList.contains('fixed')) {
                    $(window).resize(function () {
                        if (window.innerWidth > 992) {
                            // Close menu if window is resized bigger than 992 and user has fixed sidenav
                            if ($('#sidenav-overlay').length !== 0 && menuOut) {
                                removeMenu();
                            }
                            else {
                                menu.style.transform = 'translateX(0)';
                            }
                        }
                        else if (menuOut === false) {
                            if (options.edge === 'left') {
                                menu.style.transform = 'translateX(-100%)';
                            } else {
                                menu.style.transform = 'translateX(100%)';
                            }
                        }
                    });
                }

                // if closeOnClick, then add close event for all a tags in side sideNav
                if (options.closeOnClick === true) {
                    $(menu).on("click.itemclick", "a:not(.collapsible-header)", function () {
                        if (!(window.innerWidth > 992 && menu.classList.contains('fixed'))) {
                            removeMenu();
                        }
                    });
                }

                var removeMenu = function () {
                    menuOut = false;
                    // Reenable scrolling
                    $('body').css({
                        overflow: '',
                        width: ''
                    });

                    document.getElementById('sidenav-overlay').style.opacity = '0';

                    if (options.edge === 'left') {
                        menu.style.transform = 'translateX(-100%)';
                    } else {
                        menu.style.transform = 'translateX(100%)';
                    }

                    // Callback
                    if (typeof(options.onClose) === 'function') {
                        options.onClose.call(this, $(menu));
                    }
                }

                $this.off('click.sidenav').on('click.sidenav', function () {
                    if (menuOut === true) {
                        menuOut = false;
                        removeMenu();
                    } else {
                        // Disable Scrolling
                        var $body = $('body');
                        var $overlay = $('<div id="sidenav-overlay"></div>');
                        var oldWidth = $body.innerWidth();
                        $body.css('overflow', 'hidden');
                        $body.width(oldWidth);

                        if (options.edge === 'left') {
                            menu.style.transform = 'translateX(0%)';
                        } else {
                            menu.style.transform = 'translateX(-100%)';
                        }

                        // Overlay close on click
                        $overlay.css('opacity', 0)
                            .click(function () {
                                menuOut = false;
                                removeMenu();
                                $overlay[0].style.opacity = 0;
                                window.setTimeout(function () {
                                    $overlay.remove();
                                }, 100);
                            });

                        // Append body
                        $('.page').append($overlay);
                        $overlay[0].style.opacity = 1;
                        menuOut = true;

                        // Callback
                        if (typeof(options.onOpen) === 'function') {
                            options.onOpen.call(this, $(menu));
                        }
                    }

                    return false;
                });
            });
        },
        destroy: function () {

            var $overlay = $('#sidenav-overlay');
            $overlay.trigger('click');
            $(this).off('click');
            $overlay.remove();

            var menuId = $(this).attr('data-activates');
            var menu = document.getElementById(menuId);

            menu.classList.remove('side-nav--inited');

        },
        show: function () {
            this.trigger('click');
        },
        hide: function () {
            $('#sidenav-overlay').trigger('click');
        }
    };


    $.fn.sideNav = function (methodOrOptions) {
        if (methods[methodOrOptions]) {
            return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
            // Default to "init"
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + methodOrOptions + ' does not exist on jQuery.sideNav');
        }
    };
});



// WEBPACK FOOTER //
// ./Private/Scripts/materialize-modify/sideNav.js